import {
    REGISTER,
    REGISTER_DUPLICATE,
    REGISTER_ERROR,
    REGISTER_INITIAL,
    REGISTER_SUCCESS,
    RegisterAction,
    RegisterState,
} from '../_types/register';

const initialState: RegisterState = {
    data: null,
    loading: false,
    error: null,
    duplicate: false,
};

export default (state = initialState, action: RegisterAction): RegisterState => {
    switch (action.type) {
        case REGISTER_SUCCESS:
            return {
                ...initialState,
                data: action.payload,
            };
        case REGISTER:
            return {
                ...state,
                loading: true,
            };
        case REGISTER_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case REGISTER_DUPLICATE:
            return {
                ...initialState,
                duplicate: true,
                error: action.payload,
            };
        case REGISTER_INITIAL:
            return initialState;
        default:
            return state;
    }
};
